import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SelectedAreaDisplayer from '../../../components/SelectedAreaDisplayer';

const AreaSelectedModal = ({
  coords, handleClick, ...props
}) => (
  <Modal
    {...props}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        Gebied bepaald
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        <SelectedAreaDisplayer coords={coords} />
      </div>
    </Modal.Body>
    <Modal.Footer className="d-flex justify-content-between">
      <Button variant="outline-primary" onClick={props.onHide}>
        Wijzig gebied
      </Button>
      <Button onClick={handleClick}>Doorgaan</Button>
    </Modal.Footer>
  </Modal>
);

AreaSelectedModal.propTypes = {
  coords: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.number,
    ),
  ),
  handleClick: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

AreaSelectedModal.defaultProps = {
  coords: null,
};

export default AreaSelectedModal;
